export let juneAbbreviatedLowercase = "gEFkYc";
export default {juneAbbreviatedLowercase};